// Ролята идва от JWT токена при вход: "Owner" (собственик) или "Staff" (общ акаунт на бръснарите).
export function getRole() {
  const token = localStorage.getItem('token');
  if (!token) return null;

  try {
    const payload = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
    return JSON.parse(atob(payload)).role || null;
  } catch {
    return null;
  }
}

// Токени отпреди ролите нямат role — те са само на собственика, затова се броят за Owner.
export function isOwner() {
  return getRole() !== 'Staff';
}
